import DashboardAdminContent from "page_components/admin/dashboard/Content";
import DashboardProvider from "context/admin/dashboard";
import TasksProvider from "context/admin/tasks";

const Dashboard = () => {
  return (
    <DashboardProvider>
      <TasksProvider>
        <DashboardAdminContent />
      </TasksProvider>
    </DashboardProvider>
  );
};

export default Dashboard;
